import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { formatDateTime } from '../../../../utils/dateFunctions';
import { getNameFromId } from '../../../../utils/directusFunctions';

import card from '../../../../commonStyles/rowExpand.module.css';

const StatusHistory = ({ history }) => {
    const { claimEventStatuses, claimEventStatusReasons } = useSelector(
        (state) => state.entities.directusService
    );

    return (
        <div className={card.cardView}>
            <div className={card.banner}>
                <span>Email: {history ? history.emailAddress : ''} </span>
                <span>
                    Date:{' '}
                    {history?.date ? formatDateTime(history.date).substring(0, 10) || ' - ' : ' - '}
                </span>
                <span>
                    Time:{' '}
                    {history?.date
                        ? formatDateTime(history.date).substring(19, 12) || ' - '
                        : ' - '}{' '}
                </span>
                <span>
                    New Status: {history ? getNameFromId(claimEventStatuses, history.statusId) : ''}
                </span>
            </div>

            <div className={card.content}>
                <p>
                    <span className={card.label}>
                        Reason:{' '}
                        {` ${getNameFromId(claimEventStatusReasons, history.reasonId) || 'N/A'}`}
                    </span>
                </p>
                <p>
                    <span className={card.label}> Notes: {` ${history.notes || ' - '}`}</span>
                </p>
            </div>
        </div>
    );
};

StatusHistory.propTypes = {
    history: PropTypes.object
};

export default StatusHistory;
